<div data-test-id="activate-account-background" class="background">
  <img
    data-test-id="activate-account-background-image"
    src="/assets/dxp/img/background.png"
    alt=""
    srcset=""
  />
</div>

<div
  data-test-id="activate-account-wrapper"
  class="wrapper"
  *transloco="let t; read: 'activateAccount'"
>
  @if (loading$ | async) {
    <mat-spinner data-test-id="activate-account-spinner" diameter="70"></mat-spinner>
  }
  <!--
    SA-21772: an account whose sign-up started in the mobile app is sent back into the app
    already signed in, rather than to the login page. Sits outside success$ because IT
    activations resolve it false and are redirected from finalize() - this page only ever
    renders for them when that redirect was deliberately held back for this hand-off.
  -->
  @if ((loading$ | async) === false && mobileAppRedirectUrl) {
    <div data-test-id="activate-account-status-success" class="status status-success">
      <h1 data-test-id="activate-account-mobile-return-h1">{{ t('successH1') }}</h1>
      <p data-test-id="activate-account-mobile-return-p">{{ t('successParagraph') }}</p>
      <a appClickable
        data-test-id="activate-account-return-to-app-link"
        role="button"
        class="button"
        href="javascript:void(0);"
        (click)="returnToApp()"
        >{{ t('returnToAppButton') }}</a
      >
    </div>
  } @else if (success$ | async; as success) {
    <div data-test-id="activate-account-status-success" class="status status-success">
      @if ((loading$ | async) === false) {
        <h1 data-test-id="activate-account-success-h1">{{ t('successH1') }}</h1>
        <p data-test-id="activate-account-success-p">{{ t('successParagraph') }}</p>
        <a appClickable
          data-test-id="activate-account-redirect-to-login-link"
          role="button"
          class="button"
          href="javascript:void(0);"
          (click)="redirectToLogin()"
          >{{ t('loginButton') }}</a
        >
      }
    </div>
  } @else {
    @if ((loading$ | async) === false && !isActiveUser && !isLinkExpired && !isDuplicateError) {
      <div data-test-id="activate-account-status-failure" class="status status-failure">
        <p data-test-id="activate-account-error-p">{{ t('errorH1') }}</p>
        <h1 data-test-id="activate-account-error-h1">
          {{ (error$ | async) || t('errorParagraph') }}
        </h1>
      </div>
    }
    @if ((loading$ | async) === false && isLinkExpired) {
      <div data-test-id="activate-account-status-failure" class="status status-failure">
        <h1 data-test-id="activate-account-failure-h1">{{ t('shfyErrorH1') }}</h1>
        <p data-test-id="activate-account-failure-p">{{ t('shfyErrorParagraph') }}</p>
        <a appClickable
          data-test-id="activate-account-login-btn"
          role="button"
          class="button"
          href="javascript:void(0);"
          (click)="redirectToLogin()"
          >{{ t('shfyLoginButton') }}</a
        >
      </div>
    }
    @if ((loading$ | async) === false && isActiveUser) {
      <div data-test-id="activate-account-status-failure" class="status status-failure">
        <h1 data-test-id="activate-account-active-user-error-h1">
          {{ t('shfyActiveUserErrorH1') }}
        </h1>
        <p data-test-id="activate-account-active-user-error-p">
          {{ t('shfyActiveUserErrorParagraph') }}
        </p>
      </div>
    }
    @if ((loading$ | async) === false && isDuplicateError) {
      <div data-test-id="activate-account-status-failure" class="status status-failure">
        <h1 data-test-id="activate-account-duplicate-fiscal-error">
          {{ t('shfyDuplicateFiscalCodeErrorH1') }}
        </h1>
        <p
          data-test-id="activate-account-duplicate-fiscal-error-p"
          [innerHTML]="(error$ | async) || t('errorParagraph')"
        ></p>
      </div>
    }
  }
</div>
